import { FormikHelpers } from "formik";

import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfDepartmentSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";
import DepartmentSearchForm from "./DepartmentSearchForm";

const emptyDepartmentSearchForm: IDepartmentSearchForm = {
  sapCode: "",
  unID: "",
  description: "",
  deleted: "",
  placeID: ""
};

const SearchDepartment = ()  => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfDepartmentSearchForm(activeFilters) ? activeFilters as IDepartmentSearchForm : emptyDepartmentSearchForm;

  const handleSubmit = async (values: IDepartmentSearchForm, { setSubmitting }: FormikHelpers<IDepartmentSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <DepartmentSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} /> 
  )
}


export default SearchDepartment;